import { Component } from "@angular/core";
import { AgFns } from "app/shared/ag-fns";
import { JoHeader } from "app/model/entities/entity-model";

import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import {
  EntityFinderDialog,
  EntityFinderParams,
} from "app/shared/entity-finder.dialog";
import { DbQueryService } from "app/shared/db-query.service";

@Component({
  template: EntityFinderDialog.HTML,
  host: { hostID: crypto.randomUUID().toString() },
  standalone: false,
})
export class JobOrderFinderDialogComponent extends EntityFinderDialog<
  JoHeader,
  EntityFinderParams
> {
  constructor(
    ref: DynamicDialogRef,
    config: DynamicDialogConfig<EntityFinderParams>,
    public dbQueryService: DbQueryService
  ) {
    super(ref, config);
    const title = "Select Job Order";

    Object.assign(this.config, {
      header: title,
      // width: '800px;',
      // height: '530px',
      rowModelType: "serverSide",
    });
  }

  override getColDefsAndSortModel() {
    const colDefs = [
      { headerName: "Id", field: "id", filter: "agNumberColumnFilter" },
      {
        headerName: "Account",
        field: "account.accountName",
        filter: "agTextColumnFilter",
      },
      {
        headerName: "Status",
        field: "joStatusId",
        filter: "agTextColumnFilter",
      },
      { headerName: "Date", field: "joDate", filter: "agDateColumnFilter" },
    ];

    const sortModel = [{ colId: "id", sort: "asc" as const }];
    return [colDefs, sortModel] as const;
  }

  override async initDatasource() {
    let q = this.dbQueryService.uow
      .createQuery(JoHeader, "JoHeaders")
      .expand("account");
    const ds = AgFns.buildDatasource(() => q);
    return ds;
  }
}
